import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";

import freshpaintReducer from "../reducers";

const reduxMiddleware = compose(
  applyMiddleware(thunk),
  // prettier-ignore
  // @ts-ignore
  window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f
);

export const store = createStore(freshpaintReducer, reduxMiddleware);
export type StoreState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
